import type { CSSProperties } from 'react';

interface LinkProps {
  text: string;
  href: string;
  external?: boolean;
  className?: string;
  style?: CSSProperties;
}

export function LinkView({ text, href, external = true, className, style }: LinkProps) {
  if (!href.startsWith('https://')) return null;
  return (
    <a
      href={href}
      className={`text-blue-600 underline hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300${className ? ` ${className}` : ''}`}
      style={style}
      {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
    >
      {text}
    </a>
  );
}
